"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _reduxForm = require("redux-form");
var _FormField = _interopRequireDefault(require("./FormField"));
var _FieldDisplay = _interopRequireDefault(require("./FieldDisplay"));
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var FormRendererSection = function FormRendererSection(props) {
  var editMode = props.editMode,
    section = props.section,
    hiddenFields = props.hiddenFields;
  if ((0, _utils.isSectionEmpty)(section, hiddenFields)) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.FormSection, {
    name: section.id,
    className: "ui-form-renderer-section"
  }, section.display_name && /*#__PURE__*/_react["default"].createElement("h3", null, section.name), (0, _lodash.orderBy)(section.questions, 'display_order', 'asc').map(function (question) {
    return editMode ? /*#__PURE__*/_react["default"].createElement(_FormField["default"], {
      key: question.id,
      question: question,
      hiddenFields: hiddenFields,
      section: section
    }) : /*#__PURE__*/_react["default"].createElement(_FieldDisplay["default"], {
      key: question.id,
      question: question,
      hiddenFields: hiddenFields
    });
  }));
};
FormRendererSection.propTypes = {
  editMode: _propTypes["default"].bool.isRequired,
  section: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    display_name: _propTypes["default"].bool,
    name: _propTypes["default"].string,
    questions: _propTypes["default"].array
  }).isRequired,
  hiddenFields: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = FormRendererSection;